import Symbol from "./Symbol";
import { INSPECTOR_AUTOMATIC_CAPACITOR_BANK } from "../../../constants/inspectorConstants";

// Bancos de capacitores automáticos
class AutomaticCapacitorBank extends Symbol {
    constructor({ alias, svgSrc, label, rotable, handles, name}) {
        super("AutomaticCapacitorBank", { alias, svgSrc, label, rotable, handles, name });

        this.attributes = {
            brand: { isVisible: false, value: null, label: "Marca" },
            model: { isVisible: false, value: null, label: "Modelo" },
            ratedVoltage: { isVisible: false, value: null, label: "Voltaje nominal" },
            ratedCurrent: { isVisible: false, value: null, label: "Corriente Nominal" },
            totalKVAR: { isVisible: false, value: null, label: "kVAR Totales" },
            amountSteps: { isVisible: false, value: null, label: "No de Pasos" },
            stepsKVAR: { isVisible: false, value: null, label: "kVAR de Pasos" },
        };                
    }

    getInspector() {
        return INSPECTOR_AUTOMATIC_CAPACITOR_BANK;
    }
}

export default AutomaticCapacitorBank;
